import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/cache/")({
  staticData: {
    title: "cache.title",
  },
});
